var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMedicalServices(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 34,
    viewBox: "0 0 35 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8331 27.0004H19.1665V22.0004H24.1665V18.6671H19.1665V13.6671H15.8331V18.6671H10.8331V22.0004H15.8331V27.0004ZM4.16646 33.6671C3.2498 33.6671 2.46535 33.341 1.81313 32.6887C1.1598 32.0354 0.83313 31.2504 0.83313 30.3337V10.3337C0.83313 9.41707 1.1598 8.63263 1.81313 7.98041C2.46535 7.32707 3.2498 7.00041 4.16646 7.00041H10.8331V3.66707C10.8331 2.75041 11.1598 1.96541 11.8131 1.31207C12.4654 0.659851 13.2498 0.33374 14.1665 0.33374H20.8331C21.7498 0.33374 22.5348 0.659851 23.1881 1.31207C23.8404 1.96541 24.1665 2.75041 24.1665 3.66707V7.00041H30.8331C31.7498 7.00041 32.5348 7.32707 33.1881 7.98041C33.8404 8.63263 34.1665 9.41707 34.1665 10.3337V30.3337C34.1665 31.2504 33.8404 32.0354 33.1881 32.6887C32.5348 33.341 31.7498 33.6671 30.8331 33.6671H4.16646ZM14.1665 7.00041H20.8331V3.66707H14.1665V7.00041Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedicalServices);
export default __webpack_public_path__ + "static/media/medical_services.fcf906b0.svg";
export { ForwardRef as ReactComponent };